import React from 'react';
import CheckoutInfoContainer from '../containers/checkout_info_container';

const CheckoutInfoContext = React.createContext(new CheckoutInfoContainer());

export default CheckoutInfoContext;
